import { render } from "./Separator.vue?vue&type=template&id=a0a93f50"
import script from "./Separator.vue?vue&type=script&lang=js"
export * from "./Separator.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__